import React from 'react';

import Iframe from 'app/shared/components/common/Iframe/Iframe';
import AdminSlideDrawer from 'app/shared/componentsRestyled/common/AdminSlideDrawer';
import { WorksheetDrawer } from 'app/shared/modules/DocumentWorksheet';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { getIframeDrawerWidth } from 'constants/loanActionEditor';

import MersPreviewDrawer from '../MersPreviewDrawer';
import { mersPreviewPropType } from '../MersPreviewDrawer/MersPreviewDrawer.constants';
import LoanEditorCustomFormDrawer from '../Modals/LoanEditorCustomFormDrawer';

import { iframeBorderStyle, iframeDrawerContentStyle } from './LoanActionRunnerDrawers.styles';

/**
 * The drawers a loan-action run can open in the browser (loan editor custom form, URL iframe,
 * document worksheet, MERS preview). Rendered by every run-flow host next to useLoanActionsControls.
 */
const LoanActionRunnerDrawers = ({
  loanEditorCustomFormDrawerState = null,
  onCloseLoanEditorCustomFormDrawer,
  iframeDrawerState = null,
  onCloseIframeDrawer,
  worksheetDrawerState = null,
  onCloseWorksheetDrawer,
  mersPreviewDrawerState = null,
  onCloseMersPreviewDrawer,
}) => (
  <>
    <LoanEditorCustomFormDrawer
      customFormId={loanEditorCustomFormDrawerState?.customFormId ?? null}
      open={!_.isNil(loanEditorCustomFormDrawerState)}
      title={loanEditorCustomFormDrawerState?.title ?? ''}
      onClose={onCloseLoanEditorCustomFormDrawer}
    />

    {iframeDrawerState && (
      <AdminSlideDrawer
        content={
          <div style={iframeDrawerContentStyle}>
            <Iframe
              height="100%"
              referrerPolicy="strict-origin-when-cross-origin"
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
              src={iframeDrawerState.url}
              style={iframeBorderStyle}
              width="100%"
            />
          </div>
        }
        open={!!iframeDrawerState}
        title={iframeDrawerState.title}
        width={getIframeDrawerWidth(iframeDrawerState.size)}
        onClose={onCloseIframeDrawer}
      />
    )}

    {!!worksheetDrawerState && (
      <WorksheetDrawer
        applicationId={worksheetDrawerState.applicationId}
        checklistId={worksheetDrawerState.checklistId}
        documentTypeId={worksheetDrawerState.documentTypeId}
        loanId={worksheetDrawerState.loanId}
        open={!!worksheetDrawerState}
        title={worksheetDrawerState.title}
        onClose={onCloseWorksheetDrawer}
      />
    )}

    <MersPreviewDrawer
      open={!!mersPreviewDrawerState?.isOpen}
      preview={mersPreviewDrawerState?.preview ?? null}
      onClose={onCloseMersPreviewDrawer}
    />
  </>
);

LoanActionRunnerDrawers.propTypes = {
  onCloseLoanEditorCustomFormDrawer: PropTypes.func.isRequired,
  onCloseIframeDrawer: PropTypes.func.isRequired,
  onCloseWorksheetDrawer: PropTypes.func.isRequired,
  onCloseMersPreviewDrawer: PropTypes.func.isRequired,
  loanEditorCustomFormDrawerState: PropTypes.shape({
    customFormId: PropTypes.string,
    title: PropTypes.string,
  }),
  iframeDrawerState: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    size: PropTypes.string,
  }),
  worksheetDrawerState: PropTypes.shape({
    applicationId: PropTypes.string,
    checklistId: PropTypes.string,
    documentTypeId: PropTypes.string,
    loanId: PropTypes.string,
    title: PropTypes.string,
  }),
  mersPreviewDrawerState: PropTypes.shape({
    preview: mersPreviewPropType,
    isOpen: PropTypes.bool,
  }),
};

export default LoanActionRunnerDrawers;
